import { useEffect, useMemo, useState } from "react";
import Grid from '../../../../../components/Grid'
import { connect, useDispatch } from "react-redux";
import { Separator } from "../../../../../components/StyledComponents";
import { Group } from "../../../../../types";
import { GetPostsOutDto, Post } from "../../../../../types/post";
import CardAticle from "../../../../Dashboard/Posts/components/CardArticle";
import {
  Filters,
  Filter,
  Input,
  Label,
  CardsGrid,
  Total,
  GlobalStyle,
  Description,
  CategoryName,
  PadlockBadge,
  FiltersTitle
} from "./styles";
import EmptyState from "../../../components/EmptyState";
import Icon from "../../../../../components/Icon";
import InfinityScroll from '../../../../../components/InfinityScroll'
import { getAllCategories } from "../../../../../store/actions/category";
import { CategoryDto } from "../../../../../types/category";
import { getPosts, resetGetPosts } from "../../../../../store/actions/post";
import Skeleton from '../Skeleton'
import padlockLockIcon from "../../../../../assets/icons/padlock-lock.svg";
import padlockUnlockIcon from "../../../../../assets/icons/padlock-unlock.svg";
import CategoryListHeader from './components/CategoryListHeader'
import UnlockedCategoryMedal from "../../../../components/UnlockedCategoryMedal";
import { useWindowSize } from "../../../../../hooks/useWindowSize";

type CategoryState =
  | 'unlockable-unlocked-active'
  | 'unlockable-unlocked-inactive'
  | 'unlockable-locked-active'
  | 'unlockable-locked-inactive'
  | 'public-active'
  | 'public-inactive';

interface ComponentProps {
  posts: { pagination: { total: number }; data: Post[] };
  postsStates: {
    loading: boolean;
    error: string | boolean;
    success: boolean;
  };
  group: Group;
  groupStates: {
    loading: boolean;
    error: string | boolean;
    success: boolean;
  };
  allCategories: CategoryDto[];
  allCategoriesState: {
    loading: boolean;
    success: boolean;
    error: string | boolean;
  };
}

const Component = ({
  posts,
  postsStates,
  group,
  allCategories,
}: ComponentProps) => {
  const dispatch = useDispatch()
  const [page, setPage] = useState(0)
  const { isMobile } = useWindowSize()
  const [thereAreItems, setThereAreItems] = useState(true)
  const [mergedItems, setMergedItems] = useState<Post[]>([])
  const [totalElements, setTotalElements] = useState<number>(0)
  const [startPagination, setStartPagination] = useState<boolean>(false)
  const [activeCategoryId, setActiveCategoryId] = useState<string | undefined>();
  const [activeCategory, setActiveCategory] = useState<CategoryDto>();

  const categories = useMemo(() => {
    return [
      {
        id: "show-all",
        name: "Todos",
        description: "",
        days_to_unlock: 0,
        count_posts: totalElements,
        is_unlockable: false,
        locked_ordinal: undefined,
        user_access_data: {
          is_unlocked: true
        }
      },
      ...(!!allCategories ? allCategories : [])
    ]
  }, [allCategories, totalElements])

  const fetchData = ({ page, content_categories }: { page: number, content_categories?: string }) => {
    if (!postsStates.loading) {
      setStartPagination(true)
      let payload: GetPostsOutDto = { filters: { enrich_user_access_data: true, group_id: group?.id, show_scheduled_post: true, ...(content_categories ? { content_categories } : {}) }, pagination: { page, per_parge: 12 } };
      dispatch(getPosts(payload));
    }
  }

  const getCategoryState = (category, isActive): CategoryState => {
    if (category.is_unlockable) {
      if (category?.user_access_data?.is_unlocked) {
        return isActive
          ? 'unlockable-unlocked-active'
          : 'unlockable-unlocked-inactive';
      } else {
        return isActive
          ? 'unlockable-locked-active'
          : 'unlockable-locked-inactive';
      }
    } else {
      return isActive ? 'public-active' : 'public-inactive';
    }
  };

  /** Start the new pagination with new filter */
  const filterByCategory = (id) => {
    const newactiveCategoryId = id === "show-all" ? undefined : id;
    const newSelectedCategory = allCategories?.find(item => item?.id === Number(id))
    setMergedItems([])
    setPage(1)
    setActiveCategoryId(newactiveCategoryId);
    setActiveCategory(newSelectedCategory)
    fetchData({ page: 1, content_categories: newactiveCategoryId });
  }

  /** Paginate with the already selected filter */
  const paginate = (page) => {
    fetchData({ page, content_categories: activeCategoryId });
  }

  useEffect(() => {
    dispatch(getAllCategories({ group_id: group?.id, enrich_unlockable_data_for_user: true }));

    return () => {
      dispatch(resetGetPosts())
      setMergedItems([])
    }
  }, [])

  useEffect(() => {
    if (!!posts?.data && startPagination) {
      const newItemsObj = [...mergedItems, ...posts.data]
      setMergedItems(newItemsObj);
      setThereAreItems(!!posts && posts?.data?.length > 0 && newItemsObj.length < posts?.pagination?.total);

      /** Setting the total of elements without filters */
      if (!activeCategoryId) {
        setTotalElements(posts.pagination.total)
      }
    }
  }, [posts])

  return (
    <Grid.Container>
      <Grid.Row>
        <Grid.Col lg={10} offset={{ lg: 1 }}>

          <GlobalStyle />

          {isMobile && (
            <>
              <FiltersTitle>Filtrar por categoria:</FiltersTitle>
              <div style={{ height: 26 }} />
            </>
          )}

          <Filters>
            {categories?.filter(category => category?.count_posts && category?.count_posts > 0).map((category) => {
              const isActive = (activeCategoryId === String(category.id)) || (!activeCategoryId && category.id === 'show-all');
              const state = getCategoryState(category, isActive)

              console.log({
                name: category?.name,
                count_posts: category.count_posts,
                state,
                locked_ordinal: category?.locked_ordinal
              })
              return (
                <Filter key={`category-filter-${category.id}`}>
                  <Input
                    name="filter"
                    type="radio"
                    id={`filter-${category.id}`}
                    value={category.id}
                    onChange={(event) => {
                      if (event.target.checked) {
                        filterByCategory(event.target.value)
                      }
                    }}
                    checked={(activeCategoryId === String(category.id)) || (!activeCategoryId && category.id === 'show-all')}
                  />
                  <Label
                    htmlFor={`filter-${category.id}`}
                    blocked={category?.is_unlockable && !category?.user_access_data?.is_unlocked}
                    className={`label ${state}`}
                  >
                    <CategoryName className={isActive ? 'active' : ''}>
                      {category.name}
                    </CategoryName>

                    {(state === 'unlockable-unlocked-active' ||
                      state === 'unlockable-unlocked-inactive' ||
                      state === 'public-active' ||
                      state === 'public-inactive') &&
                      !!category.count_posts &&
                      !!category && (
                        <>
                          <Total>
                            {category.count_posts}
                            {(state === 'unlockable-unlocked-active' ||
                              state === 'unlockable-unlocked-inactive') &&
                              category?.id !== "show-all" && (
                                <UnlockedCategoryMedal category={category as CategoryDto} width="14px" height="auto" />
                              )}
                          </Total>

                        </>
                      )}

                    {(state === 'unlockable-locked-active' ||
                      state === 'unlockable-locked-inactive') && (
                        <PadlockBadge>
                          <Icon icon={padlockLockIcon} size="18px" color="white" />
                        </PadlockBadge>
                      )}
                  </Label>
                </Filter>
              );
            })}
          </Filters>

          <Separator height={{ desktop: "44px", mobile: "26px" }} />

          {activeCategory && (
            <>
              <CategoryListHeader category={activeCategory} />
              <Separator height={{ desktop: "30px", mobile: "18px" }} />
              <Description>{activeCategory?.description}</Description>
              <Separator height={{ desktop: "40px", mobile: "26px" }} />
            </>

          )}

          <InfinityScroll
            setPage={setPage}
            data={mergedItems}
            isLoading={postsStates.loading}
            page={page}
            action={paginate}
            active={thereAreItems}
            EmptyState={Skeleton}
          >
            {(!mergedItems || mergedItems?.length <= 0) && !postsStates.loading && postsStates.success ? (
              <div style={{ textAlign: "center" }}>
                <EmptyState text={
                  <>
                    <strong>Aún no se escribio ningún artículo.</strong>
                    <br /> Aguarda a que se comience a crearlos.
                  </>
                } />
              </div>
            ) : (
              <CardsGrid>
                {!!mergedItems && mergedItems?.length > 0 && (
                  <>
                    {mergedItems?.map((post, index) => (
                      <CardAticle
                        key={`card-article-${post?.id}`}
                        post={post}
                        groupInformation={group}
                        showPinAction={false}
                        coverPicHeight={100}
                        blockedPost={!!post?.user_access_data && !post?.user_access_data?.is_unlocked}
                      />
                    ))}
                  </>
                )}
              </CardsGrid>
            )}
          </InfinityScroll>

          <Separator height={{ desktop: "32px", mobile: "16px" }} />
        </Grid.Col>
      </Grid.Row>
    </Grid.Container>
  );
};

const state = ({ userStore, postStore, groupStore, categoryStore }) => {
  const { data: allCategories, states: allCategoriesState } =
    categoryStore.allCategories;
  const { data: subscriptions, states: subscriptionsStates } =
    userStore.subscriptions;
  const { data: userInformation, states: userInformationStates } =
    userStore.information;
  const { data: posts, states: postsStates } = postStore.listPosts;
  const { data: group, states: groupStates } = groupStore.group;

  return {
    subscriptions,
    subscriptionsStates,
    userInformation,
    userInformationStates,
    posts,
    postsStates,
    group,
    groupStates,
    allCategories,
    allCategoriesState,
  };
};

export default connect(state)(Component);